import axios from 'axios';
import router from '@/router';

const CODE = {
  LOGIN_TIMEOUT: 1000,
  REQUEST_SUCCESS: 0,
  REQUEST_FOBID: 1001,
};

const instance = axios.create({
  baseURL: "/stage-api/uapi",
  timeout: 10000,
  withCredentials: true,
});

instance.interceptors.retry = 3;

instance.interceptors.request.use((config) => config);

instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const { data } = response;
      if (data.code === CODE.REQUEST_SUCCESS) {
        return data;
      }else if(data.code === 5000){
        router.push(`/login`);
        window.localStorage.clear();
        console.warning(data.msg);
      }
      return response;
    }
  },
  (err) => {
    const { config } = err;
    if (!config || !config.retry) return Promise.reject(err);
    config.retryCount = config.retryCount || 0;
    if (config.retryCount >= config.retry) {
      return Promise.reject(err);
    }
    config.retryCount += 1;

    const backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve({});
      }, config.retryDelay || 1);
    });

    return backoff.then(() => instance(config));
  },
);

instance.interceptors.request.use(function (config) {
  console.log(localStorage.getItem("Token"))
  if (localStorage.getItem("Token")) {
    config.headers['Satoken'] = localStorage.getItem("Token")
    config.headers['Authorization'] = localStorage.getItem("Authorization")
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

export default instance;
